export interface PrimaryPalette {
  50: string
  100: string
  200: string
  300: string
  400: string
  500: string
  600: string
  700: string
  800: string
  900: string
  950: string
}

export function invertPrimaryPalette (palette: PrimaryPalette): PrimaryPalette {
  return {
    50: palette[950],
    100: palette[900],
    200: palette[800],
    300: palette[700],
    400: palette[600],
    500: palette[500],
    600: palette[400],
    700: palette[300],
    800: palette[200],
    900: palette[100],
    950: palette[50]
  }
}
